export type TextBubble = {
  id: string;
  text: string;
  createdAt: string;
};

type BubbleDocument = {
  version: 1;
  bubbles: TextBubble[];
};

export function parseTextBubbles(value: string): TextBubble[] {
  if (!value) return [];
  try {
    const document = JSON.parse(value) as Partial<BubbleDocument>;
    if (document.version === 1 && Array.isArray(document.bubbles) && document.bubbles.every(isTextBubble)) {
      return document.bubbles;
    }
  } catch {
    // Existing plain-text pastes are represented as one bubble.
  }
  return [{ id: "legacy", text: value, createdAt: "" }];
}

export function serializeTextBubbles(bubbles: TextBubble[]): string {
  return JSON.stringify({ version: 1, bubbles } satisfies BubbleDocument);
}

export function newestTextBubbles(bubbles: TextBubble[]): TextBubble[] {
  return [...bubbles].reverse();
}

export function withoutTextBubble(bubbles: TextBubble[], id: string): TextBubble[] {
  return bubbles.filter((bubble) => bubble.id !== id);
}

function isTextBubble(value: unknown): value is TextBubble {
  return Boolean(
    value &&
      typeof value === "object" &&
      typeof (value as TextBubble).id === "string" &&
      typeof (value as TextBubble).text === "string" &&
      typeof (value as TextBubble).createdAt === "string"
  );
}
